<template>
  <div class="row">
    <div class="col-12">
      <div class="p-1 col-6">
        <b-input-group>
          <b-form-input
            class="d-inline-block"
            placeholder="Nhập nội dung..."
          />
          <b-input-group-append>
            <b-button variant="danger">
              <feather-icon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 table-reponsive-sm">
        <table
          id="show_device"
          class="table"
        >
          <thead>
            <tr>
              <th>Tên thiết bị</th>
              <th>Series</th>
              <th>Hành động</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in itemsData"
              :key="item.id"
            >
              <td>{{ item.name }}</td>
              <td>
                <b-form-tags
                  v-model="item.seriesName"
                  input-id="tags-basic"
                  no-add-on-enter
                  placeholder=""
                />
              </td>
              <td>12</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-col
      cols="12"
      class="d-flex align-items-center justify-content-center"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="total"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-col>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink, BFormCheckbox,
  BPagination, BInputGroupAppend, BInputGroup, BFormTags,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt';
import { showToast } from '@/@core/utils/utils';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    BFormTags,
  },
  props: {
    relate_ids: Array,
  },
  setup(props, context) {
    const refListTable = ref(null)
    const dataUser = useJwt.getUser();

    const perPage = ref(10)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const type = ref('')
    const keyword = ref('')
    const itemsData = ref([]);
    const dataRelateIds = ref([]);
    // if (props.relate_ids.length > 0) {
    //   props.relate_ids.forEach((item) => {
    //     dataRelateIds.value.push(item.id);
    //   });
    // }

    const fetchAll = () => {
      store.dispatch('device/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        include: 'series_not_use',
        isPaginate: 1,
      })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            itemsData.value = result.data.data
            total.value = result.data.total;

            itemsData.value.forEach(element => {
              element.seriesName = element.series_not_use.map(o => o.name)
            });
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery], () => {
      refetchData()
    })

    const refetchData = () => {
      fetchAll()
    }

    // const excellentSearchQuery = () => {
    //   searchQuery.value = keyword.value
    // }

    fetchAll()
    return {
      // tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      // excellentSearchQuery,
      keyword,
      itemsData,
      dataUser,
      dataRelateIds,
    }
  },
  methods: {
    updateStatus(item) {
      this.$emit('updateRelate', item)
    },
  },
}
</script>
<style lang="scss">
#modalState {
  .modal-dialog {
    max-width: 70% !important;
  }
}

#show_device {
  .b-form-tags-button {
    display: none;
  }
}
</style>
